<div class="d-flex">
    <div class="sidebar-navigation navigation-fourth-bar">
        <gtw-screens (load-screens)="loadHistoryScreen($event)"></gtw-screens>
        @if (appNavigation.length == 0) {
<mat-progress-bar
            color="primary"
            mode="indeterminate">
        </mat-progress-bar>
}
        <div class="custom-scroll-container">
            <div class="custom-scroll">
                <div class="ap-navigation-demo-wrapper">
                    <ap-navigation
                        [title]="'GTW'"
                        [(selectedIndex)]="selectedIndex"
                        [(selectedSubIndex)]="selectedSubIndex"
                        [avatarName]="'GTW'"
                        [navList]="navList"
                        [width]="'94px'"
                        [solid]="solid"
                        [hasHeader]="!simple"
                        [hasFooter]="false"
                        [hasLogo]="false"
                        [collapsed]="collapsed"
                        [showTooltip]="true"
                        [direction]="'right'"
                        [toggleFromSuffixIconOnly]="false"
                        [styleClass]="'gtw-sidebar-nav'"
                        (onCollapsedItems)="onCollapsedSidebar($event)"
                        (onClick)="redirect($event)">
                    </ap-navigation>
                </div>
            </div>
        </div>
        <!-- <gtw-app-footer></gtw-app-footer> -->
        <div class="sidebar-footer">
            <div class="d-flex align-items-center">
                <div class="sidebar-footer-wrapper p-2">
                    <div class="ap-pwc-logo"></div>
                </div>
            </div>
        </div>
        
    </div>    
</div>


